import {
  UserCheck,
  SearchCheck,
  Wallet,
  Lock,
  Zap,
} from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const reasons = [
  {
    icon: UserCheck,
    title: "Perunding Berpengalaman",
    desc: "Pasukan kami berpengalaman dalam landskap pembiayaan Malaysia.",
  },
  {
    icon: SearchCheck,
    title: "Semakan Percuma, Tanpa Komitmen",
    desc: "Ketahui kelayakan anda tanpa sebarang kos atau tekanan.",
  },
  {
    icon: Wallet,
    title: "Tiada Bayaran Pendahuluan",
    desc: "Kami tidak mengenakan yuran tersembunyi atau deposit awal.",
  },
  {
    icon: Lock,
    title: "Sulit & Telus",
    desc: "Maklumat anda dijaga rapi dan hanya digunakan untuk semakan.",
  },
  {
    icon: Zap,
    title: "Maklum Balas Pantas",
    desc: "Respons segera melalui WhatsApp — tanpa borang yang rumit.",
  },
];

export const KenapaPilih = () => (
  <section
    data-testid="kenapa-pilih-section"
    className="relative noise-overlay bg-navy py-20 sm:py-28 overflow-hidden"
  >
    <div
      className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-gold/10 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="max-w-2xl">
          <p className="text-sm text-gold uppercase tracking-widest font-semibold">
            Kenapa Pilih Kami
          </p>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Kenapa Pilih EY 58 Group?
          </h2>
        </div>
      </Reveal>

      <div
        data-testid="kenapa-pilih-grid"
        className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {reasons.map((reason, i) => (
          <Reveal key={reason.title} delay={i * 0.07}>
            <div className="h-full rounded-2xl border border-white/10 bg-navy-light/60 backdrop-blur-sm p-7 transition-[transform,border-color] duration-200 hover:-translate-y-1 hover:border-gold/40">
              <reason.icon className="w-8 h-8 text-gold" />
              <h3 className="mt-5 font-heading text-lg font-semibold text-white">
                {reason.title}
              </h3>
              <p className="mt-2.5 text-sm text-slate-300 leading-relaxed">
                {reason.desc}
              </p>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.35}>
          <div className="flex h-full flex-col items-start justify-center rounded-2xl bg-gold p-7">
            <h3 className="font-heading text-lg font-bold text-navy">
              Masih ragu-ragu?
            </h3>
            <p className="mt-2 text-sm text-navy/80 leading-relaxed">
              Semakan awal adalah percuma. Tiada apa-apa untuk dirisikokan.
            </p>
            <WhatsAppButton
              location="kenapa_pilih"
              testId="kenapa-pilih-whatsapp-button"
              size="sm"
              className="mt-5"
            >
              Tanya Kami
            </WhatsAppButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
